var _circle, _path, _circle2, _path2, _circle3, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconClients = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "bold",
  enableBackground: "new 0 0 24 24",
  height: 512,
  viewBox: "0 0 24 24",
  width: 512,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 10,
  r: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.67 13.4c-1.01.76-1.67 1.98-1.67 3.35v.25h-4.25c-.41 0-.75-.34-.75-.75v-.5c0-1.52 1.23-2.75 2.75-2.75h2.5c.52 0 1.01.15 1.42.4z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 10,
  r: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m24 15.75v.5c0 .41-.34.75-.75.75h-4.25v-.25c0-1.37-.66-2.59-1.67-3.35.41-.25.9-.4 1.42-.4h2.5c1.52 0 2.75 1.23 2.75 2.75z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9.5,
  r: 3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.75 14h-5.5c-1.517 0-2.75 1.233-2.75 2.75v1.5c0 .414.336.75.75.75h9.5c.414 0 .75-.336.75-.75v-1.5c0-1.517-1.233-2.75-2.75-2.75z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClients, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_clients.13b9ece3.svg";
export { ForwardRef as ReactComponent };